export default "__VITE_ASSET__ce7384f9__"